<template>
  <div
    style="padding: 0 10px; max-height: 600px; overflow-y: auto; overflow-x: hidden;"
  >
    <div v-if="linkItems.length === 0">
      <p class="text-center">
        No links added yet. Click the "Add" button to add a new link.
      </p>
    </div>
    <div
      v-for="(linkItem, index) in linkItems"
      :key="index"
      class="mb-3"
    >
      <b-card bg-variant="light">
        <b-form-row>
          <b-col>
            <b-form-group label="X">
              <b-form-input
                v-model="linkItem.x"
                type="number"
                @input="updateResultData"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Y">
              <b-form-input
                v-model="linkItem.y"
                type="number"
                @input="updateResultData"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Width">
              <b-form-input
                v-model="linkItem.width"
                type="number"
                @input="updateResultData"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Height">
              <b-form-input
                v-model="linkItem.height"
                type="number"
                @input="updateResultData"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="7">
            <b-form-group label="Link">
              <b-form-input
                v-model="linkItem.link"
                type="text"
                @input="updateResultData"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Add from page">
              <b-form-input
                v-model="linkItem.addFromPage"
                type="number"
                @input="updateResultData"
              />
            </b-form-group>
          </b-col>
          <b-col class="d-flex justify-content-center align-items-end mb-3">
            <b-button
              variant="danger"
              @click="removeLink(index)"
            >
              <i class="fas fa-trash" />
            </b-button>
          </b-col>
        </b-form-row>
      </b-card>
    </div>

    <b-col class="d-flex justify-content-end mt-3 mb-3">
      <b-button
        variant="primary"
        @click="addLink"
      >
        Add
      </b-button>
    </b-col>
  </div>
</template>

<script>
const defaultLinkItem = () => ({
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  link: '',
  addFromPage: 1,
});

export default {
  name: 'ExportLinksTab',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      linkItems: [],
      resultData: [],
    };
  },
  watch: {
    links: {
      handler(newVal) {
        const links = Array.isArray(newVal) ? newVal : [];
        if (JSON.stringify(links) !== JSON.stringify(this.resultData)) {
          this.linkItems = links.map(linkItem => ({...defaultLinkItem(), ...linkItem}));
          this.updateResultData();
        }
      },
      deep: true,
      immediate: true,
    },
    resultData(newResultData) {
      this.$emit('data-updated', newResultData);
    },
  },
  methods: {
    addLink() {
      this.linkItems.push(defaultLinkItem());
      this.updateResultData();
    },
    removeLink(index) {
      this.linkItems.splice(index, 1);
      this.updateResultData();
    },
    updateResultData() {
      this.resultData = this.linkItems.map(linkItem => ({
        x: +linkItem.x,
        y: +linkItem.y,
        width: +linkItem.width,
        height: +linkItem.height,
        link: linkItem.link,
        addFromPage: +linkItem.addFromPage,
      }));
    },
  },
}
</script>

<style scoped>
.fas:hover {
  color: black !important;
}
</style>
